module.exports = __webpack_public_path__ + "media/images/flags/64/Namibia-fd6d126bcc3c221e3ac1d8d44bd5d5a6.png";